'use client'

import { Image, Spacer, Text } from '@vinted/web-ui'
import { useContext } from 'react'

import { GetShippingLabelContext } from '@marketplace-web/shipping-services-provider/shipping-services-provider-feature'
import { useTranslate } from '@marketplace-web/shared/i18n'
import { useAsset } from '@marketplace-web/domain/assets'
import { TransactionSide } from '@marketplace-web/messaging/conversation-messaging-data'

type Props = {
  userSide?: TransactionSide | null
}

const Carrier = ({ userSide }: Props) => {
  const translate = useTranslate('conversation.get_shipping_label.modal')
  const {
    state: {
      labelOptions: { labelOptions },
    },
  } = useContext(GetShippingLabelContext)

  const asset = useAsset('/assets/shipping')

  const isReturnFlow = userSide === TransactionSide.Buyer
  const CARRIER_ICON_PLACEHOLDER = 'carrier-placeholder.svg'

  if (!labelOptions) return null

  return (
    <>
      <Spacer />
      <div className="u-flexbox">
        <Image
          src={labelOptions?.carrier.iconUrl}
          size={Image.Size.Large}
          styling={Image.Styling.Rounded}
          fallbackSrc={asset(CARRIER_ICON_PLACEHOLDER)}
        />
      </div>
      <Text
        type={Text.Type.Heading}
        alignment={Text.Alignment.Center}
        width={Text.Width.Parent}
        text={translate('send_with', {
          carrier_name: labelOptions?.carrier.name,
        })}
        as="p"
      />
      {!isReturnFlow && (
        <Text
          as="span"
          alignment={Text.Alignment.Center}
          width={Text.Width.Parent}
          text={translate('send_with_body')}
        />
      )}
    </>
  )
}

export default Carrier
